import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState, useEffect } from "react";
import { UiLegacy } from "@silvertours/front-legacy-shared";
import { StyledLabel, StyledCheckbox, CheckboxWrapper } from "./Checkbox.styles";
var Checkbox = function(_param) {
    var label = _param.label, _checked = _param.checked, checked = _checked === void 0 ? false : _checked, onChange = _param.onChange, props = _object_without_properties(_param, [
        "label",
        "checked",
        "onChange"
    ]);
    var ref = useState(checked), isChecked = ref[0], setIsChecked = ref[1];
    useEffect(function() {
        setIsChecked(checked);
    }, [
        checked
    ]);
    var handleChange = function(event) {
        setIsChecked(event.target.checked);
        onChange === null || onChange === void 0 ? void 0 : onChange(event);
    };
    return /*#__PURE__*/ _jsxs(StyledLabel, {
        children: [
            /*#__PURE__*/ _jsx(StyledCheckbox, _object_spread_props(_object_spread({}, props), {
                type: "checkbox",
                onChange: handleChange
            })),
            /*#__PURE__*/ _jsx(CheckboxWrapper, {
                isChecked: isChecked,
                children: isChecked && /*#__PURE__*/ _jsx(UiLegacy.SvgIcon, {
                    name: "check"
                })
            }),
            label
        ]
    });
};
export { Checkbox };
